module.exports = __webpack_public_path__ + "static/media/pic-copy-3.5a9fb9ce.png";